export default "__VITE_ASSET__BE7SUap6__"